// Montessori
import React from 'react';
import MootCourt2024  from 'views/MootCourt2024';

const Montessoripage = () => {
  return <MootCourt2024/>;
};

export default Montessoripage;